const ExternalLinks = {
  terms: "/files/Terms & Conditions mazuri 01082023 .pdf",
  privacy: "/files/Privacy Policy MAZURI GAMEFI.pdf",
};

export default ExternalLinks;
